import React from 'react';
import { noop } from '@prisjakt/ui-base';
import * as S from './styles';

type TextInputProps = {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  label?: string;
  defaultValue?: string;
  disabled?: boolean;
  type?: 'text' | 'password' | 'email' | 'number';
  placeholder?: string;
  tabIndex?: number;
  helper?: React.ReactNode;
  warning?: boolean;
  className?: string;
  children?: React.ReactNode;
  inputRef?: React.RefObject<HTMLInputElement>;
  required?: boolean;
  customInputProps?: object;
  minLength?: number;
  maxLength?: number;
  variant?: 'default' | 'rounded';
  autoFocus?: boolean;
  ariaLabel?: string;
  autoComplete?: string;
};

const TextInput = ({
  name,
  onChange = noop,
  onKeyUp = noop,
  label,
  disabled = false,
  defaultValue,
  type = 'text',
  placeholder = undefined,
  tabIndex = 0,
  helper = null,
  warning = false,
  className = undefined,
  children = null,
  inputRef,
  required = false,
  minLength,
  maxLength,
  customInputProps = {},
  variant = 'default',
  autoFocus,
  autoComplete,
  ariaLabel,
}: TextInputProps) => (
  <S.InputWrapper className={className}>
    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
    <S.Label htmlFor={name}>
      <S.LabelText>{label}</S.LabelText>
      {children}
    </S.Label>

    <S.Input
      autoFocus={autoFocus}
      warning={warning}
      required={required}
      name={name}
      id={name}
      type={type}
      defaultValue={defaultValue}
      placeholder={placeholder}
      tabIndex={tabIndex}
      disabled={disabled}
      onChange={onChange}
      onKeyUp={onKeyUp}
      ref={inputRef}
      minLength={minLength}
      maxLength={maxLength}
      variant={variant}
      aria-label={ariaLabel}
      autoComplete={autoComplete}
      {...customInputProps}
    />

    <S.Helper warning={warning}>{helper}</S.Helper>
  </S.InputWrapper>
);

export default TextInput;
